module.exports = __webpack_public_path__ + "img/ic_image2.b47ffaaf.svg";